
/* eslint-disable */
import React from 'react';
import FlashMessage from 'react-flash-message'

export const AlertMessage = (props) => {
  return (
    <FlashMessage duration={4000}>
      <div className={props.error ? "alert alert-danger" : "alert alert-success"}>{props.error ? props.error : props.success}</div>
    </FlashMessage>
  );

}